import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { OrdersRoutingModule } from './orders-routing.module'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { NgrxFormsModule } from 'ngrx-forms'
import { OrdersReducers } from './orders.root.state'
import { OrdersDashboardComponent } from './orders-dashboard/orders-dashboard.component'
import { MatTableModule } from '@angular/material/table'
import { TranslateModule } from '@ngx-translate/core'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatIconModule } from '@angular/material/icon'
import { MatListModule } from '@angular/material/list'
import { MatTabsModule } from '@angular/material/tabs'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatRadioModule } from '@angular/material/radio'
import { FilterComponent } from './orders-dashboard/filter/filter.component'
import { OrdersListComponent, SortOrderPipe } from './orders-dashboard/orders-list/orders-list.component'
import { OrdersTableComponent } from './orders-dashboard/orders-table/orders-table.component'
import { MatCardModule } from '@angular/material/card'
import { OrderEffects } from './data/data.effects'
import { ChangePaymentMethodDialogComponent } from './orders-dashboard/change-payment-method-dialog/change-payment-method-dialog.component'
import { MatDialogModule } from '@angular/material/dialog'
import { MatSelectModule } from '@angular/material/select'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatSortModule } from '@angular/material/sort'
import { AccountModule } from '../account/account.module';
import { ConfirmDialogComponent } from './orders-dashboard/confirm-dialog/confirm-dialog.component'
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator'
import { MatPaginatorIntlGerman } from './orders-dashboard/orders-list/MatPaginatorIntlGerman';
import { ComplaintFormComponent } from './orders-dashboard/complaint-form/complaint-form.component'

@NgModule({
  declarations: [
    OrdersDashboardComponent,
    FilterComponent,
    OrdersListComponent,
    OrdersTableComponent,
    ChangePaymentMethodDialogComponent,
    ConfirmDialogComponent,
    SortOrderPipe,
  ],
  imports: [
    CommonModule,
    OrdersRoutingModule,
    StoreModule.forFeature('orders', OrdersReducers),
    EffectsModule.forFeature([OrderEffects]),
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatTableModule,
    MatSortModule,
    NgrxFormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatToolbarModule,
    MatPaginatorModule,
    MatIconModule,
    MatCardModule,
    MatListModule,
    MatTabsModule,
    MatSidenavModule,
    MatRadioModule,
    MatDialogModule,
    MatSelectModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    AccountModule,
    ComplaintFormComponent,
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: MatPaginatorIntlGerman }],
})
export class OrdersModule {}
